function cov_1f5ipf7en7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockRightFilled.tsx";
  var hash = "46f440ce6fe4e34040f5b6626c7831726fcd62bd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockRightFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "46f440ce6fe4e34040f5b6626c7831726fcd62bd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1f5ipf7en7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1f5ipf7en7();
var Icon = (cov_1f5ipf7en7().s[0]++, {
  name: 'unlock-right-filled',
  svg: "<path d=\"M12 1.75C14.8995 1.75 17.25 4.10051 17.25 7V7.5H14.75V7C14.75 5.48122 13.5188 4.25 12 4.25C10.4812 4.25 9.25 5.48122 9.25 7V10H19C20.1046 10 21 10.8954 21 12V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V12C3 10.8954 3.89543 10 5 10H6.75V7C6.75 4.10051 9.10051 1.75 12 1.75Z\" fill=\"currentColor\"/>"
});
export default Icon;